import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import HomePage from './pages/HomePage';
import UserHistoryPage from './pages/UserHistoryPage';
import SearchPage from './pages/SearchPage';
import RecommendationPage from './pages/RecommendationPage';
import DetailPage from './pages/DetailPage';
import KioskDisplayPage from './pages/KioskDisplayPage';
import KioskResultsPage from './pages/KioskResultsPage';
import KioskUploadPage from './pages/KioskUploadPage';

// The kiosk routes (/search-qr, /search-qr/upload) are standalone full-screen
// experiences for the fair-booth flow — no app chrome around them.
function AppShell() {
  const location = useLocation();
  const isKiosk = location.pathname.startsWith('/search-qr');

  return (
    <div className="App">
      {!isKiosk && <Navbar />}
      <Routes>
        <Route path="/history" element={<UserHistoryPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/recommendationpage" element={<RecommendationPage />} />
        <Route path="/detail/:movieid" element={<DetailPage />} />
        <Route path="/search-qr" element={<KioskDisplayPage />} />
        <Route path="/search-qr/results" element={<KioskResultsPage />} />
        <Route path="/search-qr/upload" element={<KioskUploadPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
